import { render, staticRenderFns } from "./SettingGroup.vue?vue&type=template&id=024827be&scoped=true&"
import script from "./SettingGroup.vue?vue&type=script&lang=js&"
export * from "./SettingGroup.vue?vue&type=script&lang=js&"
import style0 from "./SettingGroup.vue?vue&type=style&index=0&id=024827be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024827be",
  null
  
)

export default component.exports